import { Component, OnInit, Injector, PLATFORM_ID, Inject, Renderer2, Optional } from '@angular/core';
import { isPlatformServer } from '@angular/common';
import { LangService } from './services/lang.service';
import { Meta } from '@angular/platform-browser';

import { environment } from '../environments/environment';
import { Lang } from './models/lang';
import { HeadLinkService } from './services/head-link.service';
import { metaAttrList } from './const/meta-attribute-list';
import { LANG_TOKEN } from './const/tokens';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

  title = 'CARZY';
  toTopButtonVisible = false;
  lang: Lang;

  // router-outletにより呼び出されたComponentへの参照
  private componentRef;

  constructor(
    @Optional() @Inject(LANG_TOKEN) private serverLang: string,
    private injector: Injector,
    private metaService: Meta,
    private renderer: Renderer2,
    private headLinkService: HeadLinkService,
    private langService: LangService,
    @Inject(PLATFORM_ID) private platformId: object,
  ) {}

  ngOnInit() {
    this.setupCurrentLang();
    this.setNotoSansLink();
  }

  private setupCurrentLang() {
    const lang = this.getLang();
    this.langService.setCurrentLang(lang);
    this.lang = lang;
  }

  private setNotoSansLink() {
    if (this.lang === 'ja') {
      this.headLinkService.setNotoSansLink();
    }
  }

  private getLang() {
    if (isPlatformServer(this.platformId)) {
      return (this.serverLang === 'ja') ? 'ja' : 'en';
    } else {
      const requestPath = window.location.pathname;
      const matches = requestPath.match(/^\/(ja|en)/);
      if (matches) {
        const lang = (matches[1] === 'en') ? 'en' : 'ja';
        return lang;
      }
      return this.langService.getCurrentLang();
    }
  }

  onActivate(event) {
    this.componentRef = event;
    this.removeTags();
    this.removeBodyClassName();
  }

  private removeTags() {
    metaAttrList.forEach(attr => {
      this.metaService.removeTag(attr);
    });
    if (environment && !environment.production) {
      this.metaService.removeTag('name="robots"');
      this.metaService.addTags([
        { name: 'robots', content: 'noindex, nofollow, noarchive' }
      ]);
    }
  }

  private removeBodyClassName() {
    if (isPlatformServer(this.platformId)) {
      return;
    }
    const classNameList = [
      'stocklist_page_body',
      'cardetail_page_body',
      'not_found_page_body',
    ];
    classNameList.forEach(className => {
      this.renderer.removeClass(document.body, className);
    });
  }

}
